import React, { useCallback, useEffect, useRef, useState } from "react";
import { Alerts, Button, Checkbox, Col, CountryDropdown, DatePicker, Input, Radio, Row, Select, Step, Steps, TextArea, TimePicker, Toast, Toggle } from "@kaleyra/emmy";
import { debounce, isEmpty } from "lodash";
import moment, { Moment } from "moment";
import TemplateAttachIcon from '../../../../../../assets/templateAttachIcon.svg';
import Styles from './index.module.scss';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { networkCall, apiBaseUrl } from '../../../../../../utils/networkCall';
import { SUPPORT_URL } from '../../../../../../config.json';
import { checkTextEncodingType, validateEmail, validateOnlyNumbers, validatePhoneNumber, validateSpecialChar, validateURL,removeEmojisTextfield } from "../../../../../../utils";
import cn from "classnames";

const TOTAL_STEP_COUNT = 2;
const KEYWORD_LENGTH = 30;

enum ReplyTypeEnum {
    instant = 0,
    scheduled
}

enum TriggerTypeEnum {
    instant = 0,
    scheduled
}

export type IOptions = {
    label: string,
    value: string
}

export const TemplateTypeSidebar = {
    AUTO_REPLY_BODY: 'AUTO_REPLY_BODY',
    AUTO_REPLY_EXPIRY_BODY: 'AUTO_REPLY_EXPIRY_BODY'
}

export type MapStateType = {
    selectedTemplateId: string;
    templateData: any;
    urlList: any;
    selectedUrlId: string;
    createdUrl: string;
    callbackProfileList: any[];
    profile: any;
    recepientList: any[];
    countryList: any[];
};

export type DispatchPropsType = {
    onSelectTemplate: (templatesData: any, type: string, getsidebarType: (type: string) => void) => void;
    onSelectUrl: (urlData: any, type: string, getsidebarType: (type: string) => void) => void;
    validateKeyword: (keyword: string, vmnNumber: string, numberType: string, cb: (res: any, flag: boolean) => void) => void;
    onLoadUrls: () => void;
    loadCallbackProfiles: () => void;
    onLoadTemplates: () => void;
    onSaveNewConfiguration: (formData: any, cb: (res: any, flag: boolean) => void) => void;
    onLoadRecepientNumbers: () => void;
    onFormCancel: () => void;
    fetchCountryList: () => void;
    updateSelectedTemplateInStore: (templateId: string) => void;
};

const NewConfigurations: React.FC<MapStateType & DispatchPropsType> = ({ onSelectTemplate, updateSelectedTemplateInStore,selectedTemplateId, selectedUrlId, validateKeyword, templateData, urlList, onLoadUrls, onSelectUrl, loadCallbackProfiles, callbackProfileList, createdUrl, onLoadTemplates, onSaveNewConfiguration, onLoadRecepientNumbers, profile, recepientList, onFormCancel, fetchCountryList, countryList }) => {

    const [activeStep, setActiveStep] = useState<number>(0);
    const [smsRoutes, setSmsRoutes] = useState<IOptions[]>([]);
    const { t } = useTranslation();

    // Select SMS recepient
    const [keyword, setKeyword] = useState<string>("");
    const [iskeywordAvailable, setKeywordAvailability] = useState<boolean>(false);
    const [recepientOptions, setRecepientOptions] = useState<IOptions[]>([]);
    const [recepient, setRecepient] = useState<any>({number:undefined,number_type:undefined});
    const [keywordExpiry, setKeywordExpiry] = useState<Moment | null>(null);
    const [isDefaultConfiguration, setDefaultConfiguration] = useState(false);

    // Auto-reply
    const [replyType, setReplyType] = useState<ReplyTypeEnum>(0);
    const [autoReplyBody, setAutoReplyBody] = useState<string>("");
    const [autoReplySenderId, setAutoReplySenderId] = useState("");
    const [autoReplyExpiryContent, setAutoReplyExpiryContent] = useState<string>("");
    const [senderIdOptions, setSenderIdOptions] = useState<any>([]);
    const [scheduledReplyTime, setScheduledReplyTime] = useState<Moment | null>(null);
    const [autoReplySelectedTemplateId, setAutoReplySelectedTemplateId] = useState("");
    const [autoReplySmsRoute, setAutoReplySMSRoute] = useState<string | undefined>(undefined);
    const [selectedTemplateSidebarType, setSelectedTemplateSidebarType] = useState("");
    const [autoReplyExpiryTemplateId, setAutoReplyExpiryTemplateId] = useState("");
    // configuration
    const [isAutoReplyActive, setAutoReplyActive] = useState<boolean>(false);
    const [isForwardActive, setForwardActive] = useState<boolean>(false);
    const [isTriggerUrlActive, setTriggerUrlActive] = useState<boolean>(false);
    const [optInActive, setOptInActive] = useState<boolean>(false);
    const [optOutActive, setOptOutActive] = useState<boolean>(false);

    const [forwardSenderIdInfo, setForwardSenderIdInfo] = useState<any>(null);
    const [forwardToInfo, setForwardToInfo] = useState<string>("");
    const [emailForwardInfo, setEmailForwardInfo] = useState<string>('');
    const [forwardSmsRoute, setForwardSMSRoute] = useState<string | undefined>(undefined);
    const [forwardIsoValue, setFowardToIso] = useState("91");
    const [forwadToTemplateId, setForwardToTemplateId] = useState("");
    const [eusenderidoptions,seteusenderidoptions] = useState<any>({});
    const [triggerType, setTriggerType] = useState<TriggerTypeEnum>(0);
    const [callbackProfile, setCallbackProfile] = useState<string | undefined>(undefined);


    const [triggerUrl, setTriggerUrl] = useState<string>('');
    const [requestBody, setRequestBody] = useState<string>('');
    const [requestHeaders, setRequestHeaders] = useState<string>('');
    const [countries, setCountries] = useState<any>([]);
    const [isItAllSenderId,setisItAllSenderId] = useState<boolean>(false);
    const [forwardChannel, setforwardChannel] = useState<string>('SMS');

    const history = useHistory();

    useEffect(() => {
        onLoadUrls();
        loadCallbackProfiles();
        onLoadTemplates();
        onLoadRecepientNumbers();
        fetchCountryList();
        if(profile?.fullProfile?.user_pod?.toLowerCase()==="eu"||profile?.fullProfile?.country_id.toString()!=="277"){
            networkCall(`get`, `/messages/identifier`,apiBaseUrl.baseUrl).then((res:any)=>{
                if(res?.data){
                    let senderarr:any = {};
                    res?.data.map((ele:any)=>{
                        senderarr[ele.identifier] = ele.identifier;
                        return ele;
                    })
                    seteusenderidoptions(senderarr);
                }
               }).catch((err: any)=>{
                console.log(err.response?.data?.message);
                });
        }
    }, [])

    useEffect(() => {
        if (templateData) {
             if(profile?.fullProfile?.user_pod?.toLowerCase()==="eu"||profile?.fullProfile?.country_id.toString()!=="277"){
                loadSenderIdOptions(eusenderidoptions)
            }else{
            loadSenderIdOptions(templateData.smsTemplatesData?.sender_array);
            }
            storeSmsRoutes(templateData.smsTemplatesData?.routes);
        }
    }, [templateData, urlList]);

    useEffect(() => {
        if (selectedTemplateId !== "") {
            const _selectedTemplate = (templateData?.smsTemplatesData?.data).find((templateData: any) => templateData.id === selectedTemplateId);

            if ((autoReplyBody + " " + _selectedTemplate.content).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + _selectedTemplate.content).length > 4000) {
                return;
            }

            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + _selectedTemplate.content);
                setAutoReplySelectedTemplateId(_selectedTemplate.template_id);
            } else {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + _selectedTemplate.content)
            }
            updateSelectedTemplateInStore("")
        }
    }, [selectedTemplateId, selectedTemplateSidebarType]);

    useEffect(() => {
        if (selectedUrlId !== "") {
            const _selectedUrl = urlList.find((urlData: any) => urlData.id === selectedUrlId);
            if ((autoReplyBody + " " + _selectedUrl.short_url).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + _selectedUrl.short_url).length > 4000) {
                return;
            }

            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + _selectedUrl.short_url);
            } else {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + _selectedUrl.short_url);
            }
        }
    }, [selectedUrlId]);

    useEffect(() => {
        if (createdUrl !== "") {
            if ((autoReplyBody + " " + createdUrl).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + createdUrl).length > 4000) {
                return;
            }
            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + createdUrl);
            } else {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + createdUrl);
            }
        }
    }, [createdUrl])

    useEffect(() => {
        handleRecepientOptions(recepientList)
    }, [recepientList]);

    useEffect(() => {
        if (Array.isArray(countryList)) {
            let country = countryList.map((item: any) => ({
                "countryid": item.country_id,
                "name": item.name,
                "code": item.code,
                "isoCode": item.iso_code
            }))
            setCountries([...country])
        }
    }, [countryList])

    const handleRecepientOptions = (recepientList: any[]) => {
        let _recipients: IOptions[] = [];
        for (const recipientItem in recepientList) {
            _recipients.push({
                label: recepientList[recipientItem].number,
                value: JSON.stringify({number:recepientList[recipientItem].number,number_type:recepientList[recipientItem].number_type_id})
            })
        }
        setRecepientOptions([..._recipients]);
    }

    const storeSmsRoutes = (routes: any[]) => {
        let _smsRoutes: IOptions[] = [];
        for (const key in routes) {
            if (key.toString() !== "OTP" && key.toString() !== "M2M") {
                _smsRoutes.push({
                    label: key,
                    value: key
                })
            }
        }
        setSmsRoutes([..._smsRoutes]);
    }

    const loadSenderIdOptions = (senderArray: Record<string, string>[]) => {
        let senderIds = [];
        for (var key in senderArray) {
            senderIds.push({ key: key?.replace(/ /g, "\u00A0"), value: senderArray[key]?.toString()?.replace(/ /g, "\u00A0") })
        }
        setSenderIdOptions([...senderIds]);
    }

    const validateKeywordCallback = (res: any, flag: boolean) => {
        if (flag) {
            setKeywordAvailability(res.data?.availability);
        } else {
            setKeywordAvailability(false);
        }
    }

    const apiCall = (keyword: string, recipient: {number: string, number_type: string} | undefined) => {
        if (recipient) {
            validateKeyword(keyword, recipient?.number,recipient?.number_type, validateKeywordCallback);
        } else {
            Toast(t('KLR03040'), "error");
        }
    }

    const checkKeywordAvailability = useCallback(
        debounce((keyword: string, recipient: {number:string,number_type:string} | undefined) => apiCall(keyword, recipient), 100),
        []);

    const handleKeywordChange = (keyword: string) => {
        setKeyword(keyword);
        if (!isEmpty(keyword) && keyword.length <= KEYWORD_LENGTH) {
            checkKeywordAvailability(keyword, recepient);
        }
    }

    const isActiveFormValid = (activeStep: number): boolean => {
        switch (activeStep) {
            case 0:
                return !isDefaultConfiguration ? (iskeywordAvailable && keyword.length <= KEYWORD_LENGTH && !validateSpecialChar(keyword) && !isEmpty(recepient?.number)) : !isEmpty(recepient?.number);
            case 1:
                let smsDetails = (!isEmpty(forwardToInfo) && !isEmpty(forwardSenderIdInfo) && (forwardIsoValue !== "91" || (forwardIsoValue === "91" && !isEmpty(forwadToTemplateId) && isTemplateIdValid(forwadToTemplateId))) && !isEmpty(forwardSmsRoute));
                let emailDetails = (!isEmpty(emailForwardInfo) && validateEmail(emailForwardInfo));
                let flag1 = !isForwardActive || (isForwardActive && (forwardChannel === "SMS_EMAIL" ? (smsDetails && emailDetails):((forwardChannel === "SMS" && smsDetails) || (forwardChannel === "EMAIL" && emailDetails))));
                let flag2 = !isTriggerUrlActive || (isTriggerUrlActive && triggerType === 0 && !isEmpty(triggerUrl) && validateURL('url', triggerUrl) || (isTriggerUrlActive && triggerType === 1 && !isEmpty(callbackProfile)))
                let flag3 = !isAutoReplyActive || (isAutoReplyActive && isContentValid(autoReplyBody) && (!keywordExpiry || keywordExpiry && isContentValid(autoReplyExpiryContent) && autoReplyExpiryTemplateId?.length > 0 && isTemplateIdValid(autoReplyExpiryTemplateId)) && !isEmpty(autoReplySmsRoute) && !isEmpty(autoReplySenderId) && !isEmpty(autoReplyBody) && isTemplateIdValid(autoReplySelectedTemplateId));
                return flag1 && flag2 && flag3;
            default:
                return true;
        }
    }

    const saveConfigurationForm = () => {
        const formPayload: any = {
            "keyword": !isEmpty(keyword) ? keyword : undefined,
            "vmn_number": recepient?.number,
            "expired_at": keywordExpiry?.unix(),
            "is_default": recepient?.number_type === "4"? 0: Number(isDefaultConfiguration),
            "meta_data": {number_type: Number(recepient?.number_type), opt_sender_all_config: isItAllSenderId? 1: 0}
        }
        if (isAutoReplyActive) {
            formPayload["auto_reply_settings"] = {
                "sender_id": autoReplySenderId,
                "route": autoReplySmsRoute,
                "message": autoReplyBody,
                "template_id": autoReplySelectedTemplateId,
                "expiry_content": keywordExpiry ? autoReplyExpiryContent : "",
                "expiry_template_id":keywordExpiry ? autoReplyExpiryTemplateId: "",
                "is_scheduled": Boolean(replyType),
                "scheduled_time": replyType === 1 && scheduledReplyTime?.unix()
            }
        } 
        if (isForwardActive) {
            switch(forwardChannel) {
                case "SMS":
                    formPayload["forward_settings"] = {
                        "to": forwardToInfo ? `${forwardIsoValue} ${forwardToInfo}` : "",
                        "sender_id": forwardSenderIdInfo,
                        "route": forwardSmsRoute || undefined,
                        "template_id": forwardIsoValue === "91" ? forwadToTemplateId : ""
                    }
                    break;

                case "EMAIL":
                    formPayload["forward_settings"] = {
                        "email": emailForwardInfo || undefined,
                    }
                    break;
            
                default:
                    formPayload["forward_settings"] = {
                        "to": forwardToInfo ? `${forwardIsoValue} ${forwardToInfo}` : "",
                        "email": emailForwardInfo || undefined,
                        "sender_id": forwardSenderIdInfo,
                        "route": forwardSmsRoute || undefined,
                        "template_id": forwardIsoValue === "91" ? forwadToTemplateId : ""
                    }
                    break;
            }
        }
        if (isTriggerUrlActive) {
            formPayload["trigger_url_settings"] = {
                "url": triggerType === 0 && triggerUrl,
                "request_body": triggerType === 0 && requestBody,
                "request_headers": triggerType === 0 && requestHeaders,
                "callback_profile_id": triggerType === 1 && callbackProfile,
            }
        }
        if(optInActive || optOutActive){
            formPayload["opt_settings"] = optInActive?"OPT-IN":"OPT-OUT";
        }
        onSaveNewConfiguration(formPayload, createCallback);
    }

    const createCallback = (response: any, flag: boolean) => {
        if (flag) {
            Toast(response?.message, "success");
            history.goBack();
        }
        else {
            let regexToCleanErr = /[*\t\n\r]/gm
            let errorMsg = response?.data?.error?.msg?.replace(regexToCleanErr,'');
            Toast(errorMsg, "error");
        }
    }   

    const handleActiveForm = () => {
        if (activeStep < TOTAL_STEP_COUNT - 1) {
            setActiveStep((prevStep: number) => ++prevStep);
        }

        if (activeStep === TOTAL_STEP_COUNT - 1) {
            saveConfigurationForm();
        }
    }

    const handleKeywordValidationLabeltype = () => {
        return keyword === "" ? undefined : ((iskeywordAvailable && !validateSpecialChar(keyword) && keyword.length <= KEYWORD_LENGTH) ? "success" : "error")
    }

    const handleTemplateIdValidationLabelType = (templateId: string) => {
        return ((templateId?.length === 0) || (validateOnlyNumbers(templateId) && (templateId?.length >= 12 && templateId?.length <= 30)) ? "success" : "error");
    }

    const handleTemplateIdValidationLabel = (templateId: string) => {
        return ((templateId?.length === 0) || (validateOnlyNumbers(templateId) && ((templateId?.length === 0) || (templateId?.length >= 12 && templateId?.length <= 30))) ? "" : "Invalid Template Id");
    }

    const isTemplateIdValid = (templateId: string) => {
        return handleTemplateIdValidationLabelType(templateId) === "success" && handleTemplateIdValidationLabel(templateId) === "";
    }

    const handleKeywordValidationLabel = () => {
        if (keyword.length > KEYWORD_LENGTH) {
            return t('KLR03053');
        }
        if (validateSpecialChar(keyword)) {
            return t('KLR03055a');
        }
        if (keyword === "") {
            return null;
        } else {
            return (iskeywordAvailable ? t('KLR03041') : t('KLR03042'));
        }
    }

    const getCallbackProfileOptions = () => {
        let callbackProfileOptions: IOptions[] = [];
        callbackProfileList.map((callbackProfileItem: any) => {
            callbackProfileOptions.push({ label: callbackProfileItem.title, value: callbackProfileItem.profile_id });
        });
        return callbackProfileOptions;
    }

    const handleRecipientOnChange = (recp: any)  => {
        if (recp.number_type === "4") { 
            setDefaultConfiguration(false) 
        };
        setRecepient(recp);
    }

    const renderSelectSMSRecepientBody = () => {
        return (
            <div className={Styles.selectSMSWrapper}>
                {activeStep === 0 ?
                    <p className={Styles.stepDescription}>{t('KLR03043')}</p> :
                    <div className={Styles.stepDetails}>
                        <p className={Styles.stepDescription}>{t('KLR03012')} <span>{recepient?.number}</span></p>
                        {keyword && <p className={Styles.stepDescription}>{t('KLR03013')} <span>{keyword}</span></p>}
                        {keywordExpiry && <p className={Styles.stepDescription}>{t('KLR03044')} <span>{keywordExpiry?.format("YYYY-MM-DD") || "-"}</span></p>}
                    </div>
                }
                {activeStep === 0 &&
                    <>
                        <Row className={cn(Styles.selectSMSFormRow2, recepient?.number_type === "4"?Styles.hideDefaultConfigCheck:"")}>
                            <Col size={6}>
                                <Checkbox label={t('KLR03019')} disabled={recepient?.number_type === "4"} checked={isDefaultConfiguration} onChange={(e: any) => { setDefaultConfiguration(e.target.checked); if (e.target.checked) { setKeyword("") } }} />
                            </Col>
                        </Row>
                        <Row className={Styles.selectSMSFormRow1}>
                            <Col size={6}>
                                <Select placeholder={t('KLR03045')} label={t('KLR03045')} options={recepientOptions} value={recepient?.number} onChange={(e: any) => handleRecipientOnChange(JSON.parse(e))}></Select>
                            </Col>
                            <Col gutter size={6}>
                                <Input placeholder={t('KLR03013')}
                                    disabled={isDefaultConfiguration}
                                    label={t('KLR03013')}
                                    onChange={(e: any) => handleKeywordChange(e.target.value)}
                                    value={keyword}
                                    showBottomLabelSpace={true}
                                    bordered
                                    bottomLabelType={handleKeywordValidationLabeltype()}
                                    bottomLabel={handleKeywordValidationLabel()}
                                />
                            </Col>
                        </Row>
                        <Row className={Styles.selectSMSFormRow2}>
                            <DatePicker placeholder={t('KLR03044')}
                                value={keywordExpiry}
                                showTime
                                showSecond={false}
                                onChange={(date: any) => setKeywordExpiry(date)}
                                disabledDate={(current: any) => {
                                    return current && (current < moment().startOf('minutes') || current > moment().add(3, 'years'));
                                }}
                                allowClear />
                        </Row>
                        <Row className={Styles.submitBtns}>
                            <Button type="tertiary" onClick={onFormCancel}>{t('mainCancel')}</Button>
                            <Button type="primary" disabled={!isActiveFormValid(activeStep)} onClick={handleActiveForm}>{t('flwNext')}</Button>
                        </Row>
                    </>}
            </div>
        )
    }

    const isContentValid = (contentBody: string) => {
        return contentBody.trim().length > 0
    }

    const renderAutoReplyBody = () => {
        return (
            <div>
                {activeStep <= 1 ?
                    <p className={Styles.stepDescription}>{t('KLR03046')}</p> :
                    <div className={Styles.stepDetails}>
                        <p className={Styles.stepDescription}>{t('BLD00613')}<span>{recepient?.number}</span></p>
                        <p className={Styles.stepDescription}>{t('KLR03047')}<span>{autoReplyExpiryContent}</span></p>
                        <p className={Styles.stepDescription}>{t('KLR03048')}<span>{replyType === 0 ? t('KLR03025') : t('KLR03026')}</span></p>
                    </div>
                }
                {activeStep === 1 &&
                    <>
                        <div className={Styles.configurationBodyWrapper}>
                            <Row className={Styles.configurationFormRow}>
                                <div className={Styles.sectionInfo}>
                                    <h2 className={Styles.heading}>{t('KLR03021')}</h2>
                                    <p className={Styles.stepDescription}>{t('KLR03049')}</p>
                                </div>
                                <Toggle checked={isAutoReplyActive} onChange={(flag: boolean) => setAutoReplyActive(flag)} />
                            </Row>
                            {isAutoReplyActive &&
                                <>
                                    <Row className={Styles.formSelectRow}>
                                        <Select showBottomLabelSpace={false} placeholder={t('BLD00613')} label={t('BLD00613')} options={senderIdOptions} onChange={(value: any) => setAutoReplySenderId(value)}></Select>
                                    </Row>
                                    <Row className={Styles.autoReplyFormRow}>
                                        <TextArea placeholder={t('KLR00104')}
                                            value={autoReplyBody}
                                            onChange={(e: any) => {if(removeEmojisTextfield(e.target.value)){setAutoReplyBody(e.target.value)}}}
                                            showDetailsFooter={true}
                                            characterLimit={4000}
                                            showInsertLinkOption={true}
                                            showBottomLabelSpace={false}
                                            showMessageCount={true}
                                            showAttachmentOption
                                            bottomLabelType={(autoReplyBody.length === 0 || isContentValid(autoReplyBody)) ? "default" : "error"}
                                            showEncodingInfo
                                            encodingText={`${checkTextEncodingType(autoReplyBody)} Encoding`}
                                            customAttachIcon={TemplateAttachIcon}
                                            onCustomAttach={() => onSelectTemplate(templateData?.smsTemplatesData?.data || [], TemplateTypeSidebar.AUTO_REPLY_BODY, (type: string) => setSelectedTemplateSidebarType(type))}
                                            rows={5}
                                            onInsertLink={() => { onSelectUrl(urlList, TemplateTypeSidebar.AUTO_REPLY_BODY, (type: string) => setSelectedTemplateSidebarType(type)); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_BODY) }} />
                                    </Row>
                                    <Row className={Styles.scheduledReplyFormRow}>
                                        <Select label={t('KLR03022')} showBottomLabelSpace={false} placeholder={t('KLR03022')} value={autoReplySmsRoute} options={smsRoutes} onChange={(value: any) => setAutoReplySMSRoute(value)} />
                                    </Row>
                                    <Row className={Styles.scheduledReplyFormRow}>
                                        <Input label={t('verifyTemplateId')} placeholder={t('verifyTemplateId')} value={autoReplySelectedTemplateId} onChange={(e: any) => setAutoReplySelectedTemplateId(e.target.value)} showBottomLabelSpace={true}
                                            bordered
                                            bottomLabelType={handleTemplateIdValidationLabelType(autoReplySelectedTemplateId)}
                                            bottomLabel={handleTemplateIdValidationLabel(autoReplySelectedTemplateId)} />
                                    </Row>
                                    {keywordExpiry && <Row className={Styles.autoReplyFormRow}>
                                        <TextArea placeholder={t('KLR03050')}
                                            label={t('KLR03050')}
                                            value={autoReplyExpiryContent}
                                            onChange={(e: any) => {if(removeEmojisTextfield(e.target.value)){setAutoReplyExpiryContent(e.target.value)}}}
                                            showDetailsFooter={true}
                                            characterLimit={4000}
                                            showInsertLinkOption={true}
                                            showBottomLabelSpace={false}
                                            showMessageCount={true}
                                            showAttachmentOption
                                            showEncodingInfo
                                            bottomLabelType={(autoReplyExpiryContent.length === 0 || isContentValid(autoReplyExpiryContent)) ? "default" : "error"}
                                            encodingText={`${checkTextEncodingType(autoReplyExpiryContent)} Encoding`}
                                            customAttachIcon={TemplateAttachIcon}
                                            onCustomAttach={() => onSelectTemplate(templateData?.smsTemplatesData?.data || [], TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY, (type: string) => setSelectedTemplateSidebarType(type))}
                                            rows={5}
                                            onInsertLink={() => { onSelectUrl(urlList, TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY, (type: string) => setSelectedTemplateSidebarType(type)); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY) }} 
                                        />
                                        <Input 
                                            label={t('KLR03135')} 
                                            placeholder={t('KLR03135')} 
                                            value={autoReplyExpiryTemplateId} 
                                            onChange={(e: any) => setAutoReplyExpiryTemplateId(e.target.value)} 
                                            showBottomLabelSpace={true}
                                            bordered
                                            bottomLabelType={handleTemplateIdValidationLabelType(autoReplyExpiryTemplateId)}
                                            bottomLabel={handleTemplateIdValidationLabel(autoReplyExpiryTemplateId)} 
                                        />
                                    </Row>}
                                    <span className={Styles.replyTypeText}>{t('KLR03024')}</span>
                                    <Radio name="instant" value={replyType} checked={replyType === 0} onClick={() => setReplyType(0)}>{t('KLR03025')}</Radio>
                                    <Radio name="scheduled" className={Styles.replyRadioBtn} value={replyType} checked={replyType === 1} onClick={() => setReplyType(1)}>{t('KLR03026')}</Radio>
                                    {replyType === 1 &&
                                        <div className={Styles.scheduledReplyForm}>
                                            <Row className={Styles.scheduledReplyFormRow}>
                                                <DatePicker showTime showSecond={false} placeholder={t('KLR03051')} value={scheduledReplyTime} onChange={(time: any) => setScheduledReplyTime(time)} disabledDate={(current: any) => {
                                                    return current && (current < moment().minutes(moment().minutes()+15) || current > moment().add(3, 'month'));
                                                }} allowClear />
                                            </Row>
                                        </div>}

                                </>

                            }
                        </div>
                        {renderConfigurationBody()}
                        <Row className={Styles.submitBtns}>
                            <Button type="tertiary" onClick={onFormCancel}>{t('mainCancel')}</Button>
                            <Button type="primary" disabled={!isActiveFormValid(0) || !isActiveFormValid(1)} onClick={handleActiveForm}>{t('mainSave')}</Button>
                        </Row>
                    </>
                }
            </div>
        )
    }

    const renderConfigurationBody = () => {
        return (<>
            <div className={Styles.configurationBodyWrapper}>
                <Row className={Styles.configurationFormRow}>
                    <div className={Styles.sectionInfo}>
                        <h2 className={Styles.heading}>{t('KLR03027')}</h2>
                        <p className={Styles.stepDescription}>{t('KLR03028')}</p>
                    </div>
                    <Toggle checked={isForwardActive} onChange={(flag: boolean) => setForwardActive(flag)} />
                </Row>
                {
                    isForwardActive &&
                    <>
                        <h2 className={Styles.stepDescription}>{t('receiveMessageForward')}</h2>
                        <Row className={Styles.formSelectRow}>
                            <Col size={4}>
                                <Radio name="SMS" value={"SMS"} checked={forwardChannel === "SMS"} onClick={() => setforwardChannel("SMS")}>{t('mainSMS')}</Radio>
                            </Col>
                            <Col size={4}>
                                <Radio name="EMAIL" value={"EMAIL"} checked={forwardChannel === "EMAIL"} onClick={() => setforwardChannel("EMAIL")}>{t('mainEmail')}</Radio>
                            </Col>
                            <Col size={4}>
                                <Radio name="SMS_EMAIL" value={"SMS_EMAIL"} checked={forwardChannel === "SMS_EMAIL"} onClick={() => setforwardChannel("SMS_EMAIL")}>{t('receiveMessageSMSAndEmail')}</Radio>
                            </Col>
                        </Row>
                        {new Array("SMS","SMS_EMAIL").includes(forwardChannel) && <>
                            <h2 className={Styles.stepDescription}>{t('receiveMessageSMSDetails')}</h2>
                            <Row className={Styles.configurationToggleFormRow}>
                                <CountryDropdown
                                    data={countries}
                                    defaultSelectValue={forwardIsoValue}
                                    value={forwardToInfo}
                                    label={t('KLR03002')}
                                    onDropdownChange={(code: string) => setFowardToIso(code)}
                                    mode="iso"
                                    onChange={(e: any) => { setForwardToInfo(e.target.value); }}
                                    placeholder={t('KLR03002')}
                                />
                            </Row>
                            <Row className={Styles.formSelectRow}>
                                <Select showBottomLabelSpace={false} placeholder={t('BLD00613')} label={t('BLD00613')} options={senderIdOptions} value={forwardSenderIdInfo} onChange={(option: any) => setForwardSenderIdInfo(option)}></Select>
                            </Row>
                            <Row className={Styles.scheduledReplyFormRow}>
                                <Select label={t('KLR03022')} showBottomLabelSpace={false} placeholder={t('KLR03022')} value={forwardSmsRoute} options={smsRoutes} onChange={(value: any) => setForwardSMSRoute(value)} />
                            </Row>
                            {forwardIsoValue === "91" &&
                                <Row className={Styles.configurationToggleFormRow}>
                                    <Input label={t('verifyTemplateId')} placeholder={t('verifyTemplateId')} value={forwadToTemplateId} onChange={(e: any) => setForwardToTemplateId(e.target.value)} showBottomLabelSpace={true} bordered
                                        bottomLabelType={handleTemplateIdValidationLabelType(forwadToTemplateId)}
                                        bottomLabel={handleTemplateIdValidationLabel(forwadToTemplateId)} />
                                </Row>}
                        </>}
                        {new Array("EMAIL","SMS_EMAIL").includes(forwardChannel) && <Row className={Styles.configurationToggleFormRow}>
                            <h2 className={Styles.stepDescription}>{t('receiveMessageEmailDetails')}</h2>
                            <Input placeholder={t('KLR03029')}
                                label={t('KLR03029')}
                                value={emailForwardInfo}
                                bottomLabelType={(isEmpty(emailForwardInfo) || validateEmail(emailForwardInfo)) ? "default" : "error"}
                                onChange={(e: any) => setEmailForwardInfo(e.target.value)}
                            />
                        </Row>}
                    </>
                }
                <Row className={Styles.configurationFormRow}>
                    <div className={Styles.sectionInfo}>
                        <h2 className={Styles.heading}>{t('KLR03016')}</h2>
                        <p className={Styles.stepDescription}>{t('KLR03030')}</p>
                    </div>
                    <Toggle checked={isTriggerUrlActive} onChange={(flag: boolean) => setTriggerUrlActive(flag)} />
                </Row>
                {
                    isTriggerUrlActive &&
                    <>
                        <span className={Styles.replyTypeText}>{t('KLR00424')}</span>
                        <Radio name="trigger_url" value={triggerType} checked={triggerType === 0} onClick={() => setTriggerType(0)}>{t('KLR03016')}</Radio>
                        <Radio name="callback_id" className={Styles.replyRadioBtn} value={triggerType} checked={triggerType === 1} onClick={() => setTriggerType(1)}>{t('KLR03031')}</Radio>
                        {triggerType === 0 ?
                            <div className={Styles.scheduledReplyForm}>
                                <Row className={Styles.scheduledReplyFormRow}>
                                    <>
                                        <Row className={Styles.configurationToggleFormRow}>
                                            <Input placeholder={t('KLR03016')}
                                                label={t('KLR03016')}
                                                value={triggerUrl}
                                                onChange={(e: any) => setTriggerUrl(e.target.value)}
                                                showBottomLabelSpace
                                                bottomLabel="Ex: http://website.com/api.php?recipient=<recipient>&source=<source>"
                                                bottomLabelType={validateURL('url', triggerUrl) ? "default" : "error"}
                                                className={Styles.inputWithBottomLabel}
                                            />
                                        </Row>
                                        <Row className={Styles.configurationToggleFormRow}>
                                            <Input placeholder={t('reqBody')}
                                                label={t('reqBody')}
                                                value={requestBody}
                                                onChange={(e: any) => setRequestBody(e.target.value)}
                                                className={Styles.inputWithBottomLabel}
                                                showBottomLabelSpace
                                                bottomLabel="Ex: recipient=<recipient>&source=<source>"
                                                bottomLabelType="default"
                                            />
                                        </Row>
                                        <Row className={Styles.configurationToggleFormRow}>
                                            <Input placeholder={t('KLR03032')}
                                                label={t('KLR03032')}
                                                value={requestHeaders}
                                                onChange={(e: any) => setRequestHeaders(e.target.value)}
                                                className={Styles.inputWithBottomLabel}
                                                showBottomLabelSpace
                                                bottomLabel="Ex: Content-Type=application/json"
                                                bottomLabelType="default"
                                            />
                                        </Row>
                                    </>
                                </Row>
                            </div> :
                            <div className={Styles.scheduledReplyForm}>
                                <Alerts className={Styles.infoBannerContent} type="draft" content={<>{t('KLR03176')} <a href={`${SUPPORT_URL}docs/account-settings-callback-profiles`} target="_blank" rel="noopener noreferrer">Click here</a></>}/>
                                <Row className={Styles.scheduledReplyFormRow}>
                                    <Select placeholder={t('KLR03033')} label={t('KLR03033')} options={getCallbackProfileOptions()} value={callbackProfile} onChange={(option: any) => setCallbackProfile(option)}></Select>
                                </Row>
                            </div>}
                    </>
                }
                <Row className={Styles.configurationFormRow}>
                    <div className={Styles.sectionInfo}>
                        <h2 className={Styles.heading}>{t('optInLabel')}</h2>
                        <p className={Styles.stepDescription}>{t('subscribeSmsDesc')}</p>
                    </div>
                    <Toggle checked={optInActive} onChange={(flag: boolean) => {
                        setOptInActive(flag);
                        if(flag){
                            setOptOutActive(false);
                        }
                    }} />
                </Row>
                <Row className={Styles.configurationFormRow}>
                    <div className={Styles.sectionInfo}>
                        <h2 className={Styles.heading}>{t('optOutLabel')}</h2>
                        <p className={Styles.stepDescription}>{t('unsubscribeSmsDesc')}</p>
                    </div>
                    <Toggle checked={optOutActive} onChange={(flag: boolean) => {
                        setOptOutActive(flag);
                        if(flag){
                            setOptInActive(false);
                        }
                    }} />
                </Row>
                {optOutActive && <Row className={Styles.configurationFormRow}>
                <div className={Styles.sectionInfo}>
                    <p className={Styles.stepDescription}>{t('EnableUniversalOptOutLabel')}</p>
                </div>
                <Radio name="EnableUniversalOptOutRadio" value={isItAllSenderId} checked={!isItAllSenderId} onClick={() => setisItAllSenderId(false)}>{t('ConfiguredSenderIdRadioButton')}</Radio>
                <Radio name="EnableUniversalOptOutRadio" value={isItAllSenderId} checked={isItAllSenderId} onClick={() => setisItAllSenderId(true)}>{t('AllSenderIdRadioButton')}</Radio>
                <div></div>
                </Row>}
            </div>
        </>)
    }

    const handleStepChange = (current: number) => {
        setActiveStep(current);
    }

    return (
        <>
            <Steps
                current={activeStep}
                size="default"
                className={Styles.stepsWrapper}
                onChange={(step: any) => handleStepChange(step)}
            >
                <Step
                    title={<span className={Styles.stepTitle}>Select SMS Recipient</span>}
                    status={isActiveFormValid(0) ? "finish" : "wait"}
                    description={renderSelectSMSRecepientBody()} />
                <Step
                    title={<span className={Styles.stepTitle}>Configuration</span>}
                    status={isActiveFormValid(1) ? "finish" : "wait"}
                    description={renderAutoReplyBody()}
                />
            </Steps>
        </>)
}

export default NewConfigurations;